import {
  Alert,
  AlertIcon,
  AlertTitle,
  Box,
  CloseButton,
  Flex,
} from "@chakra-ui/react";
import { useMemo, useState } from "react";

const NotificationBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const envInfo = useMemo(() => {
    const env = process.env.REACT_APP_ENVIRONMENT; // "dev" | "sandbox" | "main"
    // const env = process.env.REACT_APP_ENVIRONMENT; // "dev" | "sandbox" | "main"

    console.log("=====env", env);

    switch (env) {
      case "dev":
        return {
          message: "Staging Environment — features may change frequently.",
          status: "info", // blue
        };
      case "prod":
        return {
          message: "Production Environment — you are working with real data.",
          status: "success", //
        };
      case "sandbox":
        return {
          message:
            "Sandbox Environment — safe for testing without affecting real data.",
          status: "info", // blue
        };
      default:
        // fallback → treat as dev
        return {
          message: "Staging Environment — features may change frequently.",
          status: "info", // blue
        };
    }
  }, []);

  if (!isVisible) return null;

  return (
    <Alert
      status={envInfo.status}
      variant="top-accent"
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="none"
      textAlign="center"
      position="relative"
    >
      <Flex align="center" justify="center">
        <AlertIcon />
        <AlertTitle>{envInfo.message}</AlertTitle>
      </Flex>

      {/* Close button stays at right corner */}
      <Box position="absolute" right="8px">
        <CloseButton onClick={() => setIsVisible(false)} />
      </Box>
    </Alert>
  );
};

export default NotificationBanner;
